import React from 'react';
import { settings, product } from '../../../../../models/entities/product/product';
import { localizationSelectors } from '../../../../../state/ducks/localization/selectors';
import { productsSelectors } from '../../../../../state/ducks/products/selectors';
import { RootState } from '../../../../../state/store/store';
import { connect } from 'react-redux';
import { document } from '../../../../../models/entities/common_subentities/document';
import { userSelectors } from '../../../../../state/ducks/user/selectors';
import MultipleDocumentFormConnected, { formMode } from '../../../commonSubEntities/documents/DocumentForm/MultipleDocumentFormConnected';

type Props = {
    mode: formMode;
    localizations?: any;
    settings?: settings;
    openedFromModal?: {
        setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    };
    confirmation?: { setConfirm: React.Dispatch<React.SetStateAction<boolean>> };
    createMultipleProductDocument: (productId: string, documents: Array<document>) => void;
    showLoader?: boolean;
    entityId?: string;
};

const ProductMultipleDocumentFormConnected = ({
    entityId,
    localizations,
    mode,
    settings,
    openedFromModal,
    confirmation,
    createMultipleProductDocument,
    showLoader
}: Props) => {
    return (
        <MultipleDocumentFormConnected<product, settings>
            entity={{ id: entityId } as product}
            mode={mode}
            localizations={localizations}
            settings={settings}
            openedFromModal={openedFromModal}
            confirmation={confirmation}
            createMultipleDocument={createMultipleProductDocument}
            showLoader={showLoader}
            typeMode="tags"
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    localizations: localizationSelectors.products(state),
    settings: productsSelectors.settingsByLanguage(state),
    showLoader: state.loading.effects.products.createMultipleProductDocument
});

const mapDispatchToProps = (dispatch: any) => ({
    createMultipleProductDocument: (productId: string, documents: Array<document>) =>
        dispatch.products.createMultipleProductDocument({ productId, documents }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductMultipleDocumentFormConnected);
